// =================== ProductsList.js ===================
import { collection, getDocs } from "firebase/firestore";
import { db } from "../components/firebaseConfig/firebaseConfig";

let cachedProducts = null;
let lastFetched = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes TTL

// Fetch products from Firestore and return as an array (cached in-memory)
export const fetchProductsList = async (forceRefresh = false) => {
  const now = Date.now();
  if (cachedProducts && !forceRefresh && (now - lastFetched < CACHE_TTL)) {
    return cachedProducts;
  }

  try {
    const querySnapshot = await getDocs(collection(db, "products"));
    const products = querySnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        _id: doc.id,
        img: data.img || "https://placehold.co/400x400?text=No+Image",
        productName: data.productName || "Unnamed Product",
        price: Math.round(Number(data.price) || 0),
        color: data.color || "N/A",
        badge: data.badge !== undefined ? data.badge : true,
        des: data.description || data.des || "No description provided",
        cat: data.category || "Other",
        brand: data.brand || "Generic Brand",
        // Extended ecommerce fields
        sku: data.sku || doc.id,
        stockQuantity: data.stockQuantity !== undefined ? data.stockQuantity : 99,
        inStock: data.stockQuantity === undefined ? true : data.stockQuantity > 0,
        variations: data.variations || [],       // e.g. [{label:"500ml"},{label:"1L"}]
        sizes: data.sizes || [],                 // e.g. ["S","M","L","XL"]
        weight: data.weight || null,             // e.g. "500g"
        dimensions: data.dimensions || null,     // e.g. "20x10x5 cm"
        tags: data.tags || [],                   // e.g. ["eco-friendly","bestseller"]
        discount: data.discount || 0,            // Percentage discount e.g. 10
        rating: data.rating || 0,               // Average rating 0-5
        reviewCount: data.reviewCount || 0,
        supplier: data.supplier || "",
        isBestSeller: data.isBestSeller || false,
        isSpecialOffer: data.isSpecialOffer || false,
        isDarazEnabled: data.isDarazEnabled || false,
        darazLastSyncQty: data.darazLastSyncQty !== undefined ? data.darazLastSyncQty : null,
        darazLink: data.darazLink || "",
        // Computed fields
        discountedPrice: data.discount
          ? Math.round(Number(data.price) * (1 - data.discount / 100))
          : Math.round(Number(data.price) || 0),
      };
    });
    cachedProducts = products;
    lastFetched = now;
    return products;
  } catch (error) {
    console.error("Error fetching products: ", error);
    return cachedProducts || [];
  }
};

export const clearProductsCache = () => {
  cachedProducts = null;
  lastFetched = 0;
};
